import LocationForm from 'components/locations/locationForm';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { locationSelector } from 'slices/locationSlice';
import { fetchLocationsListPage } from 'slices/locationSlice';

const UpdateLocation = () => {
    const dispatch = useDispatch();
    const { location } = useSelector(locationSelector);
    const { id } = useParams();

    useEffect(() => {
        dispatch(fetchLocationsListPage());
    }, [dispatch]);

    if (!location.length) return <div>Loading...</div>;

    const item = location.find(t => t.id === Number(id));

    return (
        <div className='content'>
            {item ? <LocationForm item={item} /> : <div>Item not found</div>}
        </div>
    );
};

export default UpdateLocation;
